import { RENTAL_STAGES, RENTAL_MAX_STAGE } from "./rentalFormUtils";

export const BUILDER_SECTIONS = [
  {
    id: "general",
    name: "General Information",
    shortName: "General Info",
    icon: "fi fi-rr-info",
    stage: RENTAL_STAGES.GENERAL,
    essential: true,
  },
  {
    id: "gallery",
    name: "Gallery",
    shortName: "Gallery",
    icon: "fi fi-rr-gallery",
    stage: RENTAL_STAGES.GALLERY,
    essential: true,
  },
  {
    id: "pricing",
    name: "Pricing & Deposit",
    shortName: "Pricing",
    icon: "fi fi-rr-dollar",
    stage: RENTAL_STAGES.PRICING,
    essential: true,
  },
  {
    id: "availability",
    name: "Stop Sale",
    shortName: "Stop Sale",
    icon: "fi fi-rr-calendar",
    stage: RENTAL_STAGES.AVAILABILITY,
    essential: false,
  },
  {
    id: "faq",
    name: "FAQs",
    shortName: "FAQ",
    icon: "fi fi-rr-interrogation",
    stage: RENTAL_STAGES.FAQ,
    essential: false,
  },
  {
    id: "inclusions",
    name: "Inclusions",
    shortName: "Inclusions",
    icon: "fi fi-rr-check",
    stage: RENTAL_STAGES.INCLUSIONS,
    essential: false,
  },
  {
    id: "exclusions",
    name: "Exclusions",
    shortName: "Exclusions",
    icon: "fi fi-rr-cross",
    stage: RENTAL_STAGES.EXCLUSIONS,
    essential: false,
  },
  {
    id: "terms",
    name: "Terms & Conditions",
    shortName: "Terms",
    icon: "fi fi-rr-memo-circle-check",
    stage: RENTAL_STAGES.TERMS,
    essential: false,
  },
];

export const isSectionCompleted = (savedStage, sectionStage) => {
  if (sectionStage < savedStage) return true;
  if (sectionStage === RENTAL_STAGES.TERMS && savedStage >= RENTAL_MAX_STAGE) return true;
  return false;
};

export const getCompletedSectionsCount = (savedStage, hasTerms = false) =>
  BUILDER_SECTIONS.filter((item) => isSectionCompleted(savedStage, item.stage, hasTerms)).length;

export const getCompletionPercent = (savedStage, hasTerms = false) => {
  const total = BUILDER_SECTIONS.length;
  if (!total) return 0;
  return Math.round((getCompletedSectionsCount(savedStage, hasTerms) / total) * 100);
};

export const getMissingSections = (savedStage, hasTerms = false) =>
  BUILDER_SECTIONS.filter((item) => !isSectionCompleted(savedStage, item.stage, hasTerms)).map(
    (item) => item.shortName
  );

export const getBuilderResumeSectionId = (completedStage) => {
  const stage = Number(completedStage) || RENTAL_STAGES.GENERAL;
  const match = BUILDER_SECTIONS.find((item) => item.stage === stage);
  if (match) return match.id;
  const pending = BUILDER_SECTIONS.find((item) => item.stage > stage);
  return pending?.id || BUILDER_SECTIONS[BUILDER_SECTIONS.length - 1]?.id || "general";
};
